module.exports = __webpack_public_path__ + "img/gb5781.prt.49e1ec50.jpg";